import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { logout, useAuthFetchFromRestAPI } from '../../../util/api';
import { TrainingPlanDto } from '../../../../../shared/dtos/trainingplan.dto';
import TrainingPlanDetails from "../components/TrainingPlanDetails";

const TrainingPlanDetailsPage: FC = () => {
  const { authFetch } = useAuthFetchFromRestAPI();
  const params = useParams<{ therapyId: string; trainingId?: string }>();
  const therapyId = params.therapyId;
  const trainingId = params.trainingId;

  const [isLoading, setIsLoading] = useState(true);

  // TODO Add patient type
  const [patientDetails, setPatientDetails] = useState({});
  const [trainingPlan, setTrainingPlan] = useState<TrainingPlanDto | null>(null);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      setIsLoading(true);

      if (!therapyId) {
        await logout();
        return;
      }

      await fetchTherapyDetails(therapyId);
      
      if (trainingId) {
        await fetchTrainingPlan(trainingId);
      }

      setIsLoading(false);
    };

    void fetchData();
  }, []);

  const fetchTherapyDetails = async (id: string): Promise<void> => {
    // TODO add therapy type
    const therapyData = await authFetch(`/api/v1/therapies/${id}`);
    setPatientDetails(therapyData.patient);
  };

  const fetchTrainingPlan = async (id: string): Promise<void> => {
    const trainingData: TrainingPlanDto = await authFetch(`/api/v1/trainingplan/${id}`);
    setTrainingPlan(trainingData);
  };

  if (isLoading) {
    return (
      <div
        className="w-100 text-center d-flex flex-grow-1 justify-content-center text-white"
        style={{ fontSize: 30, paddingTop: 100 }}
      >
        <i className="fas fa-spin fa-cog"/>
      </div>
    );
  }

  if (!therapyId) {
    return null;
  }

  return (
    <TrainingPlanDetails
      patient={patientDetails}
      therapyId={therapyId}
      trainingPlan={trainingPlan ?? undefined}
    />
  );
};

export default TrainingPlanDetailsPage;
